

export function mision_click(event) {
	$w('#boxmision').show();
	$w('#boxvision').hide();
}

export function vision_click(event) {
	$w('#boxmision').hide();
	$w('#boxvision').show();
}

export function cierremision_mouseIn(event) {
	$w('#boxmision').hide();
}
export function cierrevision_mouseIn(event) {
	$w('#boxvision').hide();
}

import { cart } from 'wix-stores';

export function boxcart_click(event) {
	cart.showMiniCart();
}

export function iconcart_click(event) {
	cart.showMiniCart();
}